import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { automaticReLeaseConfig } from './AutomaticReLease.name';

/** 自動再リースのENUM */
enum AutomaticReLease {
  /** 自動再リースする */
  automaticReLease = '1',
  /** 自動再リースしない */
  doNotAutomaticReLease = '2',
}

const automaticReLeaseMap = new Map([
  ['1', AutomaticReLease.automaticReLease],
  ['2', AutomaticReLease.doNotAutomaticReLease],
]);

const rawValueToAutomaticReLease = rawValueToEnumWithDefault(
  automaticReLeaseMap,
  AutomaticReLease.automaticReLease,
);

const automaticReLeaseToDisplay = enumToNameWithDefault(AutomaticReLease, automaticReLeaseConfig);

const automaticReLeaseToDisplayWithPrefix = enumToNameWithDefault(
  AutomaticReLease,
  automaticReLeaseConfig,
  true,
);

export {
  AutomaticReLease,
  automaticReLeaseToDisplay,
  automaticReLeaseToDisplayWithPrefix,
  rawValueToAutomaticReLease,
};
